import React from "react";
import { connect } from "react-redux";
import { OrderedMap } from "immutable";
import { parse } from "qs";
import PropTypes from "prop-types";

import {
  getDashboardListSearchAsync,
  getDashboardListNextPageAsync,
} from "dashboard/actions/list";
import StoryList from "dashboard/components/StoryList";
import styles from "./SearchResults.css";

class SearchResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: this.getQueryFromQuerystring(this.props.location.search),
    };
  }

  componentDidMount() {
    this.props.getDashboardListSearchAsync(this.state.query);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.search !== nextProps.location.search) {
      const newQuery = this.getQueryFromQuerystring(nextProps.location.search);
      this.setState({ query: newQuery });
      this.props.getDashboardListSearchAsync(newQuery);
    }
  }

  getQueryFromQuerystring(querystring) {
    return parse(querystring, { ignoreQueryPrefix: true }).q;
  }

  render() {
    let stories = [];

    if (this.props.list && OrderedMap.isOrderedMap(this.props.list.items)) {
      stories = this.props.list.items.toArray();
    }

    return (
      <div className={styles.root}>
        <StoryList
          stories={stories}
          next={this.props.getDashboardListNextPageAsync}
          isLoadingInitialList={this.props.isLoadingInitialList}
          className={styles.storyList}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.dashboard.list,
  isLoadingInitialList: state.dashboard.ui.isLoadingInitialList,
});

const mapDispatchToProps = {
  getDashboardListSearchAsync,
  getDashboardListNextPageAsync,
};

SearchResults.propTypes = {
  list: PropTypes.object,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  getDashboardListSearchAsync: PropTypes.func.isRequired,
  getDashboardListNextPageAsync: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResults);
